import { Button, Modal, notification, Space } from "antd"
import { useClientVersionCheck } from "./versionCheckQueries"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faRotateRight } from "@fortawesome/pro-solid-svg-icons"
import { useEffect, useState } from "react"
import VSpace from "../common/VSpace"

const OldVersionWarning = () => {
  const [notificationVisible, setNotificationVisible] = useState(false)
  const clientVersionCheckQuery = useClientVersionCheck()

  useEffect(() => {
    if (notificationVisible || clientVersionCheckQuery.isFetching || !clientVersionCheckQuery.data) {
      return
    }

    if (clientVersionCheckQuery.data.showOldVersionWarning && !clientVersionCheckQuery.data.forceUpdate) {
      setNotificationVisible(true)
      notification.info({
        message: 'Page Refresh Needed',
        description: <VSpace>
          <p>
            It looks like this SynkedUP page has not been reloaded in some time and is out of date.
            Please refresh the page to get the latest updates.
          </p>
          <Button type="primary" onClick={() => window.location.reload()}>Refresh Page</Button>
        </VSpace>,
        duration: 0
      })
    }
  }, [clientVersionCheckQuery.data])

  if (clientVersionCheckQuery.isLoading || window.env?.VERSION === '4.0.0') {
    return <></>
  }

  if (clientVersionCheckQuery.data?.showOldVersionWarning && clientVersionCheckQuery.data.forceUpdate) {
    return <Modal
      open={true}
      title={<Space>
        <FontAwesomeIcon icon={faRotateRight} />
        Page Refresh Required
      </Space>}
      footer={null}
      closable={false}
    >
      <p>
        It looks like this SynkedUP page hasn't been reloaded in some time and is out of date.
        Please refresh the page to continue.
      </p>
      <p>
        If this error message does not go away after refreshing the page,
        please contact our support team using the Intercom chat button at the bottom right hand of the page.
      </p>
    </Modal>
  }

  return <></>
}

export default OldVersionWarning
